import React from "react"
import "./CategoryProfileBox.scss"
import { selectIcon, SVG } from "../../UI/selector"
import { useHistory } from "react-router-dom"

const CategoryProfileBox = ({ id, name, icon, full }) => {
  const history = useHistory()
  return (
    <div
      className="CategoryProfileBox"
      onClick={() => history.push(`/Category/${id}`)}
    >
      <p className="categoryName">{name}</p>
      <SVG
        src={selectIcon("categoryBackground")}
        alt={""}
        className="categoryBackground"
      />
      <img src={icon} className={full ? "categoryImage" : "categoryIcon"} />
    </div>
  )
}

export default CategoryProfileBox
